// Datos de las 16 sedes del Mundial 2026, indexados por el string `ground` de openfootball.
// Capacidades aproximadas (configuración mundial). Banderas por país anfitrión.

export interface Venue {
  ground: string; // clave: igual al `ground` del partido
  stadium: string;
  city: string;
  country: 'USA' | 'México' | 'Canadá';
  flag: string;
  capacity: number;
  lat: number; // coordenadas del estadio (para el clima)
  lon: number;
}

export const VENUES: Record<string, Venue> = {
  'Atlanta': { ground: 'Atlanta', stadium: 'Mercedes-Benz Stadium', city: 'Atlanta', country: 'USA', flag: '🇺🇸', capacity: 71000, lat: 33.755, lon: -84.401 },
  'Boston (Foxborough)': { ground: 'Boston (Foxborough)', stadium: 'Gillette Stadium', city: 'Foxborough', country: 'USA', flag: '🇺🇸', capacity: 65000, lat: 42.091, lon: -71.264 },
  'Dallas (Arlington)': { ground: 'Dallas (Arlington)', stadium: 'AT&T Stadium', city: 'Arlington', country: 'USA', flag: '🇺🇸', capacity: 80000, lat: 32.747, lon: -97.093 },
  'Guadalajara (Zapopan)': { ground: 'Guadalajara (Zapopan)', stadium: 'Estadio Akron', city: 'Guadalajara', country: 'México', flag: '🇲🇽', capacity: 46000, lat: 20.681, lon: -103.463 },
  'Houston': { ground: 'Houston', stadium: 'NRG Stadium', city: 'Houston', country: 'USA', flag: '🇺🇸', capacity: 72000, lat: 29.685, lon: -95.411 },
  'Kansas City': { ground: 'Kansas City', stadium: 'Arrowhead Stadium', city: 'Kansas City', country: 'USA', flag: '🇺🇸', capacity: 76000, lat: 39.049, lon: -94.484 },
  'Los Angeles (Inglewood)': { ground: 'Los Angeles (Inglewood)', stadium: 'SoFi Stadium', city: 'Inglewood', country: 'USA', flag: '🇺🇸', capacity: 70000, lat: 33.953, lon: -118.339 },
  'Mexico City': { ground: 'Mexico City', stadium: 'Estadio Azteca', city: 'Ciudad de México', country: 'México', flag: '🇲🇽', capacity: 87000, lat: 19.303, lon: -99.150 },
  'Miami (Miami Gardens)': { ground: 'Miami (Miami Gardens)', stadium: 'Hard Rock Stadium', city: 'Miami Gardens', country: 'USA', flag: '🇺🇸', capacity: 65000, lat: 25.958, lon: -80.239 },
  'Monterrey (Guadalupe)': { ground: 'Monterrey (Guadalupe)', stadium: 'Estadio BBVA', city: 'Guadalupe', country: 'México', flag: '🇲🇽', capacity: 53000, lat: 25.669, lon: -100.244 },
  'New York/New Jersey (East Rutherford)': { ground: 'New York/New Jersey (East Rutherford)', stadium: 'MetLife Stadium', city: 'East Rutherford', country: 'USA', flag: '🇺🇸', capacity: 82500, lat: 40.814, lon: -74.074 },
  'Philadelphia': { ground: 'Philadelphia', stadium: 'Lincoln Financial Field', city: 'Philadelphia', country: 'USA', flag: '🇺🇸', capacity: 69000, lat: 39.901, lon: -75.168 },
  'San Francisco Bay Area (Santa Clara)': { ground: 'San Francisco Bay Area (Santa Clara)', stadium: "Levi's Stadium", city: 'Santa Clara', country: 'USA', flag: '🇺🇸', capacity: 68500, lat: 37.403, lon: -121.970 },
  'Seattle': { ground: 'Seattle', stadium: 'Lumen Field', city: 'Seattle', country: 'USA', flag: '🇺🇸', capacity: 69000, lat: 47.595, lon: -122.332 },
  'Toronto': { ground: 'Toronto', stadium: 'BMO Field', city: 'Toronto', country: 'Canadá', flag: '🇨🇦', capacity: 45000, lat: 43.633, lon: -79.418 },
  'Vancouver': { ground: 'Vancouver', stadium: 'BC Place', city: 'Vancouver', country: 'Canadá', flag: '🇨🇦', capacity: 54500, lat: 49.277, lon: -123.112 },
};

// Código ISO del país anfitrión (para imagen de bandera).
export const COUNTRY_ISO: Record<Venue['country'], string> = {
  USA: 'us',
  'México': 'mx',
  'Canadá': 'ca',
};

export function venue(ground: string | null): Venue | null {
  return ground ? VENUES[ground] ?? null : null;
}

export function venueList(): Venue[] {
  return Object.values(VENUES).sort((a, b) => a.stadium.localeCompare(b.stadium));
}
